import React, { type FunctionComponent } from 'react'
import { Marker, type MarkerVariants } from '@retailer-platform/shared-components/src/tds'
import { ApprovalRequestState, ReviewAction } from '../../api'
import { type DomainMessages, useDomainMessages } from '../../utils/domain/intl'
import { type ApiActivityHistory, type ApiApprovalRequest } from '../../api/common'
import { sortReviewsFunc } from '../activity-history/ActivityHistory'

export type ApprovalRequestStateBadgeProps = {
  approvalRequest?: ApiApprovalRequest
  state: ApprovalRequestState
}

export const ApprovalRequestStateBadge: FunctionComponent<
  React.PropsWithChildren<ApprovalRequestStateBadgeProps>
> = ({ approvalRequest: ar, state }) => {
  const i18n = useDomainMessages({
    state: `approvalManagementLibrary.approvalRequestState.${state}` as DomainMessages,
    changesRequested: 'approvalManagementLibrary.approvalRequestState.changesRequested',
  })

  if (ar && ar.reviews && searchRecentChangeRequest([...ar.reviews].sort(sortReviewsFunc))) {
    return <Marker variant="alert" text={i18n.changesRequested} />
  }

  const variant: MarkerVariants =
    (state === ApprovalRequestState.Cancelled && 'detrimental') ||
    (state === ApprovalRequestState.Pending && 'neutral') ||
    'success'

  return <Marker variant={variant} text={i18n.state} />
}

const CSS = { fontVariationSettings: 'normal' }

const searchRecentChangeRequest = (reviews: ApiActivityHistory) => {
  if (!reviews) {
    return false
  }

  for (const review of reviews) {
    if (review.reviewContent.action === ReviewAction.Comment) {
      // "Comments" don't change the state of the approval request
      continue
    }

    if (review.reviewContent.action === ReviewAction.RequestChanges) {
      return true
    }
  }

  return false
}
